import React from "react";
import ReactTags from "react-tag-autocomplete";

class TeamRoles extends React.Component {
    state = {
        roles: [],
        role_suggestions: this.props.roles
    };

    componentDidMount() {

        this.inputRef = React.createRef();
        let roles = [];
        
        this.props.member.roles.forEach(rid => {
            this.state.role_suggestions.forEach(role => {;
                if (role.id === rid) {
                    roles.push({id: role.id, name: role.name});
                }
            });
        });

        this.setState({roles});
    }

    onDelete(i) {
        const roles = this.state.roles.slice(0);
        roles.splice(i, 1);
        this.setState({ roles }, () => {
            this.props.updateRole(this.props.member, roles);
        });
    }

    onAddition(role) {
        const roles = [].concat(this.state.roles, role);
        this.setState({ roles }, () => {
            this.props.updateRole(this.props.member, roles);
        });
    }

    render() {
        return (
            <React.Fragment>
                <form autoComplete="off" className="form form--horizontal" >
                    <ReactTags
                        ref={this.inputRef}
                        tags={this.state.roles}
                        suggestions={this.state.role_suggestions}
                        onDelete={this.onDelete.bind(this)}
                        onAddition={this.onAddition.bind(this)} 
                        placeholderText="Assign Role"  
                    />
                </form>
            </React.Fragment>
        );
    }
}

export default TeamRoles;
